export default state => state.arvato.loadingOptions;
